import { Magnifier } from '@solar-icons/react'
import { ErrorLayout } from '../components/error-layout'

export function NotFoundScreen() {
  return (
    <ErrorLayout
      code={404}
      title="Fora da quadra?"
      description="Não encontramos o que você está procurando. O endereço pode ter sido alterado ou a página não existe mais."
      icon={<Magnifier />}
      errorCode="404_PAGE_NOT_FOUND"
    />
  )
}
